import type { I18TParams } from '@/i18n.ts';
import type { WizardStepDefLeaf } from '@/wizard/types.ts';

type StepI18n = string | I18TParams;

export type WizardStepMeta = Pick<WizardStepDefLeaf<unknown>, 'title' | 'tooltip' | 'menuTitle'>;

export function wizardStepMeta(title: StepI18n, tooltip: StepI18n, menuTitle: StepI18n): WizardStepMeta {
  return { title, tooltip, menuTitle };
}

export function wizardStepMetaPrefix(prefix: string, menuTitle = `${prefix}.menuTitle`): WizardStepMeta {
  return {
    title: `${prefix}.title`,
    tooltip: `${prefix}.tooltip`,
    menuTitle,
  };
}
